function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconBin, IconFile, IconUpload } from '../../../index';

const FileUploadField = ({
  name,
  acceptedFilesExtensions = '.csv, .png, .jpg',
  onChange,
  isDisabled = false,
  isMultiple = true,
  className = '',
  style = {},
  inputRef,
  errors,
  ...rest
}) => {
  const [files, setFiles] = useState([]);

  const onLoadFile = event => {
    event.preventDefault();
    const nextFiles = [...files, ...Array.from(event.target.files || [])];
    setFiles(nextFiles);
    if (onChange) onChange(nextFiles);
  };

  const onDeleteFile = indexToDelete => {
    const nextFiles = files.filter((item, index) => index !== indexToDelete);
    setFiles(nextFiles);
    if (onChange) onChange(nextFiles);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('form-group input-file', className, {
      'input-file--disabled': isDisabled,
      'input-file--error': errors !== undefined,
      error: errors !== undefined
    }),
    style: style
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: name
  }, /*#__PURE__*/React.createElement(IconUpload, {
    color: "primary"
  }), "Upload"), /*#__PURE__*/React.createElement("input", _extends({
    ref: inputRef,
    id: name,
    name: name,
    accept: acceptedFilesExtensions,
    type: "file",
    onChange: onLoadFile,
    onClick: e => e.currentTarget.value = null,
    multiple: isMultiple,
    disabled: isDisabled || !isMultiple && files && files.length > 0
  }, rest)), /*#__PURE__*/React.createElement("div", {
    className: "help-text"
  }, "Accepted files: ", acceptedFilesExtensions), files && /*#__PURE__*/React.createElement("div", {
    className: "input-file__filelist"
  }, files.map((file, index) => /*#__PURE__*/React.createElement("div", {
    key: `fileUpload${name}${index}`,
    className: "input-file__filename"
  }, /*#__PURE__*/React.createElement(IconFile, {
    color: "text-secondary",
    size: 13
  }), /*#__PURE__*/React.createElement("span", null, file.name), /*#__PURE__*/React.createElement("div", {
    onClick: () => onDeleteFile(index)
  }, /*#__PURE__*/React.createElement(IconBin, {
    color: "text-secondary",
    size: 15
  }))))), errors && /*#__PURE__*/React.createElement("div", {
    className: "help-error"
  }, errors.message));
};

FileUploadField.propTypes = {
  name: PropTypes.string,
  acceptedFilesExtensions: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  isMultiple: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};
export default FileUploadField;